import { useTranslation } from 'react-i18next';
import { Form, Icon, Page } from '@/components';
import { useParams, useNavigate } from 'react-router-dom';
import { EditTaskTemplatePanel, TemplateTabContentKeys } from '@/views';
import { Button, Space } from 'antd';
import { useGetTaskTemplateDetailsQuery } from "@/redux";

const useIds = () => {
  const { id } = useParams<'id'>();
  const { communityId } = useParams<'communityId'>();
  return { id: id!, communityId: communityId! };
};

export function TaskTemplateEditPage() {
  const { id, communityId } = useIds();
  const { data } = useGetTaskTemplateDetailsQuery({ id });
  const { t } = useTranslation();
  const title = t('taskTemplates.details.editTitle');
  const push = useNavigate();
  const backRoute = `/communities/${communityId}#${TemplateTabContentKeys['task-templates']}`;

  return (
    <Page htmlTitle={title}>
      <Page.Paths>
        <Page.Path href="/communities">{t('communities.title')}</Page.Path>
        <Page.Path
          href={backRoute}
        >
          {data?.communityName ?? t('fetchFallbackTitle')}
        </Page.Path>
        <Page.Path
          href={backRoute}
        >
          {t('taskTemplates.title')}
        </Page.Path>
        <Page.Path>{title}</Page.Path>
      </Page.Paths>

      <Page.Body>
        <Page.Card
          actionsPosition="bottom"
          actions={
            <Space size="middle">
              <Button onClick={() => push(backRoute)}>{t('cancel')}</Button>
              <Form.Submit uid="taskTemplate-details" type="primary">
                {t('save')}
              </Form.Submit>
            </Space>
          }
          title={title}
          icon={<Icon type="template" />}
          color="#EFAC4E"
        >
          <EditTaskTemplatePanel id={id} communityId={data?.communityId} onSaved={() => push(-1)} />
        </Page.Card>
      </Page.Body>
    </Page>
  );
}